import env from '../env';
import axios from 'axios';
import moment from '../../node_modules/moment/min/moment.min.js';

class CommonService {

  static useAxios(req){
    return new Promise((resolve, reject) => {
      axios(req).then((res) => {
        // handle success
        resolve(res);
      }).catch((e) => {
        // handle error
        reject(e);
      })
    })
  }

  /*static getDataSources(req){
    return new Promise((resolve, reject) => {
      axios.get(env.ecn_backend_api+'data_sources', {params: req}).then((res) => {
        // handle success
        resolve(res);
      }).catch((e) => {
        // handle error
        reject(e);
      })
    })
  }*/

  static getFileUrl(file, isDownload=true){
    return env.file_url+file+(isDownload?'&is_download=1':''); 
  } 

  static copyText(text){
    navigator.clipboard.writeText(text);
  }

  static getIconByType(file, type, preurl){ 
    if(file){
      if(file.match(/\.(jpeg|jpg|gif|png|ico|svg|webp|avif|heif|heic)$/) != null){
        return file.includes('cuedlink.s3') ? env.file_url+file : file;
      }else if(file.match(/\.(pdf|PDF)$/)){
        return "/images/pdf_icon.png";
      }else if(file.match(/\.(xls|XLXS|XLS|xlsx|ods)$/) != null){
        return "/images/excel_icon.png";
      }else if(file.match(/\.(doc|docx|odt)$/)){
        return "/images/doc_icon.jpg";
      }else if(file.match(/\.(ppt|pptx|odp)$/)){
        return "/images/ppt.jpg";
      }else if(file.lastIndexOf(".csv")>0){
        return "/images/csv.jpg";
      }else if(file.lastIndexOf(".key")>0){
        return "/images/key.png";
      }else if(file.lastIndexOf(".wav")>0){
        return "far fa-file-audio";
      }else{
        return "/images/attachement-64.png";
      }
    }
  }

  static trimTitle(title){
    return title.length > 30 ? (title.substring(0,36) + '...'):title;
  }

  static getFileName(url){
    return url?url.substring((url.lastIndexOf('/'))+1):'';
  }
  
  static async getImgFile(url){
    try{
      const {status, data} = await axios.get(url, { 'responseType': 'blob' });
      if(status === 200){
        return URL.createObjectURL(data);
      }
    }catch(e){
      console.error(e.message);
    }
  }

  /*static removeUnusedCss(){
    document.head.querySelectorAll(`link[css-remove="true"]`).forEach(function(a){
      a.remove()
    })    
    //document.querySelectorAll('[rel="stylesheet"]');
  }*/

  /*static loadCss(file_name){
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', `/styles/${file_name}.css`);
    link.setAttribute('css-remove', "true");
    document.head.appendChild(link);
  }*/

  static formatUpdateDate(date, format){
    if(date) return moment(date).format(format || 'MMM D, YYYY');
  }

  static utcToLocal = (dateTime, format) => {
    return moment.utc(dateTime).local().format(format); 
  }

  static compareDate(date1, date2, returnType='days', nonNegative=false, addDecimal=false){
    const time1 = date2 ? moment(date2) : moment();
    const time2 = moment(date1);

    return  nonNegative ? time1.diff(time2, nonNegative, addDecimal) : time2.diff(time1, returnType, addDecimal);
  }
  
  static isToday(date){
    return moment().isSame(date, 'day');
  }

  static getCurrentDateTime(format=null){
    return moment().format(format);
  }

  static geTimeDiff(end, start){
    const ms = moment(end).diff(moment(start));
    const d = moment.duration(ms)._data;
    return `${d.hours}:${d.minutes}:${d.seconds}`;
  }

  static geTimeDiffHms(end, start){
    const ms = moment(end).diff(moment(start));
    const d = moment.duration(ms)._data;
    return {'hours': d.hours, 'minutes': d.minutes, 'seconds': d.seconds};
  }

  static stringToDate(date, addTime=false){
    if(date){
      const s = date.split(/[^0-9]/);
      if(addTime && s[3] && s[4]){
        return new Date (s[0],s[1]-1,s[2],s[3],s[4], (s[5] || '00'))
      }

      return new Date (s[0],s[1]-1,s[2], '23', '59', '59');
      //for (i=0;i<a.length;i++) { alert(a[i]); }
      //new Date (s[0],s[1]-1,s[2],s[3],s[4],s[5])
      //endDate is considering the 0:00:00 time will display one day before so add 23 59 59
    }
  }

  static calcDate(date1, date2) {
    let mdate1 = moment(date1);
    const mdate2 = moment(date2);

    const totalYears = mdate2.diff(mdate1, 'years')
    const totalDays = mdate2.diff(mdate1, 'days')
    if(totalYears > 0)
      mdate1 = mdate1.add('years', totalYears) 
    
    const monthsPassed = mdate2.diff(mdate1, 'months')
    if(monthsPassed > 0)
      mdate1 = mdate1.add('months', monthsPassed) 
    
    const weeksPassed = mdate2.diff(mdate1, 'weeks')
    if(weeksPassed > 0)
      mdate1 = mdate1.add('weeks', weeksPassed) 

    const daysPassed = mdate2.diff(mdate1, 'days')

    return {
      "totalDays":totalDays,
      "days":daysPassed,
      "years":totalYears,
      "months":monthsPassed,
      "weeks":weeksPassed,
    }

    /*
    * ref - https://blog.bitsrc.io/calculate-the-difference-between-two-2-dates-e1d76737c05a
    * calcDate() : Calculates the difference between two dates
    * @date1 : "First Date in the format MM-DD-YYYY"
    * @date2 : "Second Date in the format MM-DD-YYYY"
    * return : Object
    */
  }

  static getAge(d1, d2, addDecimal=false, fractionSize=0, dwmy='month'){
    if(d1){
      d2 = d2 || new Date();
      const r = moment(d2).diff(moment(this.stringToDate(d1)), dwmy, addDecimal); 
      if(addDecimal && fractionSize){
        return r.toFixed(fractionSize);
      }
      return r;
    }
  }

  static addDwmyToDate(date, dwmy, no, dateFormat, toDate){
    const d = moment(date).add(no, dwmy);
    if(dateFormat){
      return d.format(dateFormat);
    }else if(toDate){
      return d.toDate();
    }
    return d;
  }

  /*
    inclusivity 
    moment('2016-10-30').isBetween('2016-10-30', '2016-12-30', null, '()'); //false
    moment('2016-10-30').isBetween('2016-10-30', '2016-12-30', null, '[)'); //true
    moment('2016-10-30').isBetween('2016-01-01', '2016-10-30', null, '()'); //false
    moment('2016-10-30').isBetween('2016-01-01', '2016-10-30', null, '(]'); //true
    moment('2016-10-30').isBetween('2016-10-30', '2016-10-30', null, '[]'); //true
  */
  static isDateTimeBetween(start, end, dateTime, format, inclusivity='[]'){
    if (start && end) {
      const date = moment(dateTime, format);
      const startTime = moment(start, format);
      const endTime = moment(end, format);

      if (date.isBetween(startTime, endTime, null, inclusivity)) {
        return true;
      }else{
        return false
      }
    }
  }

  static ageDWMY(date1, date2){
    const babyAge = this.calcDate(date1, date2);
    let age_ago = babyAge.days +' days';

    if(babyAge.totalDays > 6 && babyAge.weeks > 0){
      age_ago = `${babyAge.weeks}W ${babyAge.days}D`;
    }
    
    //(feb 28)  
    if(babyAge.totalDays > 27 && babyAge.months > 0){  
      age_ago = `${babyAge.months}M ${age_ago}`;
    }

    if(babyAge.totalDays > 364 && babyAge.years > 0){  
      age_ago = `${babyAge.years}Y ${age_ago}`;
    }

    return age_ago;
  }

  static extractHostName(url){
    if(url && url.length>0){
      let u = document.createElement('a');
      u.href = url;
      return u.hostname;
    }
    return '';
  }
 
  static groupBy(xs, key) {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  static groupByMultipleKeys = (list, keys) => {
    return list.reduce((acc, obj) => {
      const compoundKey = keys.map(key => obj[key]).join('-'); 
      acc[compoundKey] = acc[compoundKey] || []; 
      acc[compoundKey].push(obj); 

      return acc;
    }, {});
  };

  static b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
     return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
     }));
  }

  static b64DecodeUnicode(str) {
     // Going backwards: from bytestream, to percent-encoding, to original string.
     return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
     }).join(''));
  }

  static subString(str){
    return str && str.substring(0,200)
  }

  static routeJourney(journeyProfile, props){
    if(journeyProfile.data.health_condition == 1){
      /*Cancer journey template*/
      //props.history.push(`/cancer/page/${journeyProfile.id}`)
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type=cancer_journey', 
      })
    }else if(journeyProfile.data.health_condition == 2){
      /*Maternal/Infant Health (Advanced) journey*/
      //props.history.push(`/infant/page/${journeyProfile.id}?type='infant_journey'`)
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type=infant_journey', 
      })
    }else if(journeyProfile.data.health_condition == 3){
      /*Infant Nutrition and Growth Assessment (Base) journey*/
      //props.history.push(`/infant/page/${journeyProfile.id}?type='infant_journey'`)
      let qp = `?type=infant_journey`
      if(journeyProfile?.child?.id)qp += `&child_id=${journeyProfile?.child?.id}`
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:qp, 
      })
    }else if(journeyProfile.data.health_condition == 5){
      /*Dementia journey*/
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type=dementia_journey', 
      })
    }
    else if(journeyProfile.data.health_condition == 7){
      /*CKD journey*/
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type=ckd_journey', 
      })
    }
    else if(journeyProfile.data.health_condition == 12){
      /*Adult Metabolic journey*/
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type=adult_metabolic', 
      })
    }else if(journeyProfile.journey_type){
      props.history.push({
        pathname:`/ecn/common/page/${journeyProfile.id}`,
        search:'?type='+journeyProfile.journey_type, 
      })
    }
  }

  static routeJourneyForm(ds, history, dataCollectedBy, goBack){
    let qs = `?type=${ds.value}&journey_type=${ds.sid}`
    if(dataCollectedBy)qs += `&data_collected_by=${dataCollectedBy}`
    if(goBack)qs += `&go_back=${goBack}`

    history.push({
      pathname:`/ecn/form/${ds.child_form}`,
      search:qs, 
      state:{'health_condition': ds.value}
    })
  }

  static numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  static linkify(inputText) {
    try{
      let replacedText, replacePattern1, replacePattern2, replacePattern3;

      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank" class="text-link">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank" class="text-link">$2</a>');

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
      replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1" class="text-link">$1</a>');

      return replacedText;
    }catch(e){
      return inputText;
    }
  }

  static listToObj(list, key){
    return list ? list.reduce((obj, item) => (obj[item[key]] = item, obj) ,{}) : {};
  }

  static listToObjData(list, key){
    return list ? list.reduce((obj, item) => (obj[item.data[key]] = item, obj) ,{}) : {};
  }

  static getFormAssessmentFields(req){
    return new Promise((resolve, reject) => {
      axios.get(env.health_backend+'training/assessment/form', {params: req}).then((res) => {
        // handle success
        resolve(res);
      })
    }) 
  }

  static listToObj(list, key){
    return list && list.reduce((obj, item) => (obj[item[key]] = item, obj) ,{});
  }

  static routeMedicalFacility(organization_id){
    return {
      isPopupMode:true,
      match:{
        params:{
          organization_id
        }
      },
      location:{
        search: ``
      }
    }
  }

  static routeOrgMemberList(organization_id){
    return {
      isPopupMode:true,
      match:{
        params:{
          organization_id,
        }
      },
      location:{
        search: ``
      }
    }
  }

  static routeCancerPath(path, journey, history, id){
    if(['symptoms', 'daily_check', 'pain_tracking', 'side_effects', 'care_giver', 'health_center'].includes(path.sid)){
      return {
        match:{
          params:{
            journey_profile_id: journey.id,
            id: id
          }
        },
        location:{
          search: `?form_id=${path.child_form}&label=${path.sid}`
        }
      }
    }if(['assess_sleep', 'assess_stress', 'diet_recall', 'physical_activity'].includes(path.sid)){
      return {
        match:{
          params:{
            journey_profile_id: journey.id,
            id: id
          }
        },
        location:{
          search: `?form_id=${path.child_form}&label=${path.sid}`
        }
      }
    }else if(['family_member'].includes(path.sid)){
      return {
        match:{
          params:{
            id: id
          }
        },
        location:{
          search: `?form_id=${path.child_form}&label=${path.sid}`
        }
      }
    }
  }

  static routeInfantPath(path, child, journey, history, parentActivityId, activityId){
    if(path.sid === 'guides'){
      history.push(`/ecn/planner/reel/${journey.id}?planner_form_id=476&label=${path.label}`, {journey, child})
    }else if(path.sid === 'calendar'){
      history.push(`/infant/schedules/${journey.id}?label=${path.label}`, {journey, child})
    }else if(path.sid === 'wellness'){
      history.push(`/ecn/chart/${journey.id}?label=${path.label}`, {journey, child})
    }else if(path.sid === 'baby'){
      //c.data.baby_age = Cs.getAge(c.data.dob_baby_formatted_date)
      const childData = {
        id_mother: journey.data?.cell_number, 
      }
      history.push(`/infant/child/form/${journey.id}/${child.id ?? ''}?label=${path.label}`, childData)
    }else if(path.sid === 'track'){
      history.push(`/ecn/path/${journey.id}?label=${path.label}`, {journey, child});
    }else if(path.sid === 'visits'){
      history.push(`/infant/activities/${journey.id}?activity_form_id=483&label=${path.label}`, {journey, child})
    }else if(path.sid === 'bfmethod'){
      history.push(`/infant/activities/${journey.id}?activity_form_id=486&label=${path.label}`, {journey, child})
    }else if(path.sid === 'instant_baby' || path.sid === 'child_birth'){
      let qp = '?label=child'
      if(journey.associated_journey_id){
        qp += `&associated_journey_id=${journey.associated_journey_id}`
      }
      if(path.is_form_wizard === 'yes')qp += '&is_form_wizard=1'; //render as form wizard
      if(path.child_form)qp += `&form_id=${path.child_form}`; //render as form wizard
      return {
        match:{
          params:{
            journey_profile_id: journey.id
          }
        },
        location:{
          search: qp,
          state:{id_mother: journey.data?.cell_number}
        }
      }
    }else if(path.sid === 'Counseling'){
      history.push(`/infant/list/counseling/reel/${journey.id}?label=${path.label}`, {journey, child})
    }else if(['birth_history', 'prior_services', 'household_details', 'addnal_info', 'household_info', 'family_details', 'adolescent', 'registration', 'mother_edu_occupation'].includes(path.sid)){
      return {
        match:{
          params:{
            journey_profile_id: journey.id,
            id: activityId
          }
        },
        location:{
          state:{id_mother: journey.data?.cell_number},
          search: `?form_id=${path.child_form}&label=${path.sid}&sid=${path.sid}`
        }
      }
    }else if(['growth_measurement', 'feeding_assessment', 'assess_cf', 'assess_bf', 'prenatal_care', 'periodic_check', 'protein_intake', 'immunization'].includes(path.sid)){
      let qp = `?activity_form_id=${path.child_form}&label=${path.sid}&sid=${path.sid}`;
      if(path.is_form_wizard === 'yes')qp += '&is_form_wizard=1'; //render as form wizard
      return {
        match:{
          params:{
            journey_profile_id: journey.id,
            id: activityId
          }
        },
        location:{
          state:{},
          search:qp 
        }
      }
    }else if(path.sid === 'case_assessment'){
      history.push(`/case/${journey.id}/assessments/${journey.created_by}`)
    }else{
      return {
        match:{
          params:{
            journey_profile_id: journey.id,
            id: activityId
          }
        },
        location:{
          search: `?form_id=${path.child_form}&label=${path.sid}&sid=${path.sid}`
        }
      }
    }
  }

  static getCardCount(screen){
    if(screen.xs){
      return 1
    }else if(screen.sm){
      return 2
    }else if(screen.md){
      return 3
    }else if(screen.lg){
      return 3
    }
  }

  static emailStatus(item){
    if(!item.is_active){
      return 'InActive'
    }
    if(item.user?.current_sign_in_at){
      return 'Login'
    }
    if(item.joined_from_invite){
      return 'Joined'
    }
    if(item.is_link_visited){
      return 'Invitation opened'
    }
    if(item.report?.app_status){
      //app_download_status
      return item.report?.app_status
    }
    if(item.is_email_sent){
      return 'Invitation sent'
    }
  }
  
  static displayRandomPhrase(i) {
    return "Translate technology innovation into successful businesses";
  }  
  
  static round(value){
    return value?Math.round(value):null;
  }

  static getSelectedText() {
    let text = "";
    if (typeof window.getSelection != "undefined") {
        text = window.getSelection().toString();
    } else if (
        typeof document.selection != "undefined" &&
        document.selection.type == "Text"
    ) {
        text = document.selection.createRange().text;
    }
    return text;
  }

  static stripeHtml(text){
    return text?.replace(/(<([^>]+)>)/gi, "");
  }

  static getSeconds(time){
    try{
      if(time){
        const a = time.split(':')
        a.length<3 && a.unshift(0);
        return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
      }
    }catch(e){
      console.log(e.message)
    }
  }

  static getBrowserType(){
    const ua = navigator.userAgent;
    if((ua.indexOf("Opera") || ua.indexOf('OPR')) != -1 ){
      return 'Opera';
    }else if(ua.indexOf("Chrome") != -1 ){
      return 'Chrome';
    }else if(ua.indexOf("Safari") != -1){
      return 'Safari';
    }else if(ua.indexOf("Firefox") != -1 ) {
      return 'Firefox';
    }else if((ua.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
      return 'IE'; 
    }
  }  
  
  static formFieldListToObj = (formsMap={}) =>{
    for (const f in formsMap){
      formsMap[f] = this.listToObj(formsMap[f], 'client_id');
    }
    return formsMap;
  }

  static searchList = (list, searchKeyword) =>{
    return list.filter(o => JSON.stringify(o)?.toLowerCase()?.indexOf(searchKeyword) > -1);
  }

  static nestedListSearch = (list, searchKeyword) =>{
    const result = this.searchList(list, searchKeyword);
    for(const o of result){
      for (const [k, v] of Object.entries(o)) {
        if(Array.isArray(v)){
          o[k] = this.searchList(v, searchKeyword);
        }
      } 
    }
    return result;
    //return list.filter(o => JSON.stringify(o)?.toLowerCase()?.indexOf(searchKeyword) > -1);
  }

  static deepCopy = (object) =>{
    return JSON.parse(JSON.stringify(object));
  }

  static setSessionStore(key, value, isJson){
    sessionStorage.setItem(key, (isJson?JSON.stringify(value):value));
  }

  static getSessionStore(key, isJson){
    let d = sessionStorage.getItem(key);
    return d && isJson?JSON.parse(d):null; 
  }

  static getCookie(name) {
    const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name))
    ?.split("=")[1];
    return cookieValue;
  }

  static getUniqueListByKeys = (arr, keys=[]) =>{
    return arr.filter((v,i,a)=>a.findIndex(v2=>keys.every(k=>v2[k] ===v[k]))===i);
  }
  
  //Remove in future download from backend
  static jsonToCsv = (data) =>{
    const headers = Object.keys(data[0]);
    const seperator = ",";
    const csv = [
        headers.map(h => `"${h}"`).join(seperator),

        ...data.map(row => headers.map(field => {
            if(typeof row[field] === "object"){
                return ""
                //${JSON.stringify(row[field])}
            }

            return `"${row[field]}"`
        }).join(seperator))
    ]

    return csv.join("\n");
  }

  static extractUrlFromRichTxt = (richText) =>{
    if(richText){
      const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
      return richText.match(urlRegex) || [];
    }
    return [];
  }

  static objCountNonNull(obj){
    return Object.keys(obj).filter(k => (obj[k]?.toString()?.length > 0))?.length;
  }

  static calcMultiColAverage(data, columns) {
    const averages = {};
    columns.forEach((column) => {
      averages[column] = (data.reduce((sum, row) => sum + (row[column] || 0), 0) / data.length).toFixed(2);
    });

    return averages;
  }
  
  static calcMultiColTotal(data, columns) {
    const totals = {};
    columns.forEach((column) => {
      totals[column] = data.reduce((sum, row) => sum + (row[column] || 0), 0);
    });
  
    return totals;
  }
  
  static calcAssessmentTotals(reports, assessmentLabels) {
    const assessmentTotals = assessmentLabels.reduce((acc, label) => {
      acc[label] = {
        answer_count: reports.reduce((sum, org) => 
          sum + (org.assessments.find(a => a.quiz_label === label)?.answer_count || 0), 0),
        examinee_count: reports.reduce((sum, org) => 
          sum + (org.assessments.find(a => a.quiz_label === label)?.examinee_count || 0), 0),
      };
      return acc;
    }, {});

    return assessmentTotals;
  }

  static getInitials = (name = '') => name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0]?.toUpperCase()).join('') || '?';

  /**
   * Converts an HTML string into an Editor.js JSON object.
   * @param {string} htmlString - The raw HTML string.
   * @returns {object} - The formatted Editor.js JSON data.
   */
  static htmlToEditorJS = (htmlString) => {
    // 1. Parse the HTML string into a DOM Document
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    let blocks = [];

    // 2. Iterate through all top-level elements in the parsed body
    const elements = Array.from(doc.body.children);

    elements.forEach((el) => {
      const tagName = el.tagName.toLowerCase();

      // We use innerHTML to preserve inline tags like <b>, <i>, <a>
      let content = el.innerHTML.trim();

      // 3. Filter out empty elements and <p><br></p> wrappers
      // If the text content is empty and it doesn't contain an image, skip it
      if (!el.textContent.trim() && !el.querySelector('img')) {
        return;
      }

      // Clean up unnecessary zero-width spaces or stray <br> tags left inside
      content = content.replace(/^<br>|<br>$/gi, '').trim();

      // If the wrapper tag (like <p>) has a style, apply it to a span wrapping the content
      const inlineStyle = el.getAttribute('style');
      if (inlineStyle) {
        content = `<span style="${inlineStyle}">${content}</span>`;
      }

      // 4. Map HTML tags to Editor.js block types
      switch (tagName) {
        // --- TEXT BLOCKS ---
        case 'p':
        case 'div':
        case 'section':
        case 'article':
          blocks.push({
            type: 'paragraph',
            data: { text: content }
          });
          break;

        // --- HEADERS ---
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
          blocks.push({
            type: 'header',
            data: {
              text: content,
              level: parseInt(tagName.replace('h', ''), 10)
            }
          });
          break;

        // --- LISTS ---
        case 'ul':
        case 'ol': {
          const items = Array.from(el.querySelectorAll('li')).map(li => li.innerHTML.trim());
          blocks.push({
            type: 'list',
            data: {
              style: tagName === 'ul' ? 'unordered' : 'ordered',
              items: items
            }
          });
          break;
        }

        // --- QUOTES ---
        case 'blockquote':
        case 'q':
          blocks.push({
            type: 'quote',
            data: {
              text: content,
              caption: el.getAttribute('cite') || '', // Optional: grabs cite attribute if it exists
              alignment: 'left'
            }
          });
          break;

        // --- IMAGES ---
        case 'img':
          blocks.push({
            type: 'image',
            data: {
              file: {
                url: el.getAttribute('src') || ''
              },
              caption: el.getAttribute('alt') || '',
              withBorder: false,
              withBackground: false,
              stretched: false
            }
          });
          break;

        case 'figure': {
          // Handles <figure><img><figcaption></figure> structures
          const img = el.querySelector('img');
          const figcaption = el.querySelector('figcaption');
          if (img) {
            blocks.push({
              type: 'image',
              data: {
                file: { url: img.getAttribute('src') || '' },
                caption: figcaption ? figcaption.innerHTML.trim() : (img.getAttribute('alt') || ''),
                withBorder: false,
                withBackground: false,
                stretched: false
              }
            });
          }
          break;
        }

        // --- CODE BLOCKS ---
        case 'pre':
        case 'code':
          blocks.push({
            type: 'code',
            data: {
              // We use textContent here to prevent HTML entities from being evaluated
              code: el.textContent.trim()
            }
          });
          break;

        // --- DELIMITERS (Horizontal Rules) ---
        case 'hr':
          blocks.push({
            type: 'delimiter',
            data: {} // Delimiter tool requires an empty data object
          });
          break;

        // --- TABLES ---
        case 'table': {
          const rows = Array.from(el.querySelectorAll('tr'));
          const tableData = rows.map(row => {
            // Grab both <td> and <th> cells
            return Array.from(row.querySelectorAll('td, th')).map(cell => cell.innerHTML.trim());
          });

          blocks.push({
            type: 'table',
            data: {
              withHeadings: el.querySelector('thead') !== null || el.querySelector('th') !== null,
              content: tableData
            }
          });
          break;
        }

        // --- FALLBACK / DEFAULT ---
        default:
          // If an inline element (like <b> or <a>) somehow ends up at the root level,
          // or if it's an unrecognized tag, wrap it safely in a paragraph block.
          if (content) {
            blocks.push({
              type: 'paragraph',
              data: {
                // Re-wrap the inner content with its original tag to preserve formatting
                text: `<${tagName}>${content}</${tagName}>`
              }
            });
          }
          break;
      }
    });

    // 5. Return the structured Editor.js JSON wrapper
    return {
      time: new Date().getTime(),
      blocks: blocks,
      version: "2.28.0"
    };
  }

  static editorJSToHtml(editorjsData) {
    if (!editorjsData) return '';

    const blocks = editorjsData?.blocks || [];
    const br = (text = '') => text.replace(/\n/g, '<br />');
    const align = (block) =>
      block.tunes?.alignment?.alignment ||
      block.tunes?.AlignmentBlockTune?.alignment ||
      block.data?.alignment || 'left';

    return blocks.map(block => {
      const { type, data, tunes } = block;

      switch (type) {

        case 'header': {
          const a = align(block), pl = (tunes?.indentTune?.indentLevel || 0) * 24;
          return `<h${data.level} class="ejs-header ejs-header-${data.level} m-b-5" style="text-align:${a};padding-left:${pl}px;white-space:pre-wrap;">${br(data.text)}</h${data.level}>`;
        }

        case 'paragraph': {
          const a = align(block), pl = (tunes?.indentTune?.indentLevel || 0) * 24;
          return `<p class="ejs-paragraph m-b-5" style="text-align:${a};padding-left:${pl}px;white-space:pre-wrap;">${br(data.text) || '&nbsp;'}</p>`;
        }

        case 'list': {
          if (data.style === 'checklist') {
            const items = data.items.filter(i => i.content).map(i => {
              const checked = i.meta?.checked || false;
              return `<li class="ejs-checklist-item ${checked ? 'ejs-checklist-checked' : ''}"><span class="ejs-checklist-box">${checked ? '✓' : ''}</span><span class="ejs-checklist-text" style="white-space:pre-wrap;">${br(i.content)}</span></li>`;
            }).join('');
            return `<ul class="ejs-checklist m-b-5">${items}</ul>`;
          }

          const tag = data.style === 'ordered' ? 'ol' : 'ul';
          const renderItems = (items) => items.filter(i => i.content).map(i => {
            const nested = i.items?.length ? `<${tag} class="ejs-list-nested">${renderItems(i.items)}</${tag}>` : '';
            return `<li class="ejs-list-item" style="white-space:pre-wrap;">${br(i.content)}${nested}</li>`;
          }).join('');
          return `<${tag} class="ejs-list ejs-list-${data.style} m-b-5">${renderItems(data.items)}</${tag}>`;
        }

        case 'image': {
          const s = tunes?.imageStyle || {};
          const border = s.border ? `border:${s.borderWidth ?? 2}px solid ${s.borderColor ?? '#000'};` : '';
          const { cropTop: t = 0, cropRight: r = 0, cropBottom: b = 0, cropLeft: l = 0 } = s;
          const clip = (t || r || b || l) ? `clip-path:inset(${t}% ${r}% ${b}% ${l}%);` : '';
          const caption = data.caption ? `<figcaption class="ejs-image-caption" style="white-space:pre-wrap;">${br(data.caption)}</figcaption>` : '';
          return `<figure class="ejs-image m-b-5"><img src="${data.file?.url}" alt="${data.caption || ''}" style="width:${s.width ?? 100}%;max-width:100%;display:block;${border}${clip}"/>${caption}</figure>`;
        }

        case 'table': {
          const s = tunes?.tableStyle || {};
          const [bw, bc, bg, tw] = [s.borderWidth ?? 1, s.borderColor ?? '#cccccc', s.headingBg ?? '#f0f0f0', s.tableWidth ?? 100];
          const cellStyle = `border:${bw}px solid ${bc};padding:6px 8px;white-space:pre-wrap;`;
          const rows = data.content.map((row, ri) =>
            `<tr class="ejs-table-row">${row.map(cell => {
              const h = data.withHeadings && ri === 0;
              return `<${h ? 'th' : 'td'} class="ejs-table-cell" style="${cellStyle}${h ? `background:${bg};font-weight:700;` : ''}">${br(cell)}</${h ? 'th' : 'td'}>`;
            }).join('')}</tr>`
          ).join('');
          return `<table class="ejs-table m-b-5" style="width:${tw}%;border-collapse:collapse;">${rows}</table>`;
        }

        case 'quote': {
          const a = align(block), qs = tunes?.quoteStyle || {};
          const [bw, bc, fill, ts, tc, cs, cc] = [qs.borderWidth ?? 3, qs.borderColor ?? '#cccccc', qs.fillColor ?? 'transparent', qs.textSize ?? 16, qs.textColor ?? '#333333', qs.captionSize ?? 13, qs.captionColor ?? '#888888'];
          const caption = data.caption ? `<cite class="ejs-quote-caption" style="font-size:${cs}px;color:${cc};font-style:italic;white-space:pre-wrap;">${br(data.caption)}</cite>` : '';
          return `<blockquote class="ejs-quote m-b-5" style="text-align:${a};border-left:${bw}px solid ${bc};background:${fill};padding:8px 12px;margin:0;border-radius:0 2px 2px 0;"><p class="ejs-quote-text" style="font-size:${ts}px;color:${tc};margin:0 0 4px;line-height:1.5;white-space:pre-wrap;">${br(data.text)}</p>${caption}</blockquote>`;
        }

        case 'checklist':
          return this.renderStyledChecklist(block);

        case 'delimiter': {
          const s = data.style || 'star';
          if (s === 'line') return `<hr class="ejs-delimiter ejs-delimiter-line m-b-5"/>`;
          const symbol = s === 'star' ? '★ ★ ★' : s === 'dash' ? '— — —' : '';
          return `<div class="ejs-delimiter m-b-5 ejs-delimiter-${s}">${symbol}</div>`;
        }

        case 'warning':
          return `<div class="ejs-warning m-b-5"><p class="ejs-warning-title" style="white-space:pre-wrap;">${br(data.title)}</p><p class="ejs-warning-message" style="white-space:pre-wrap;">${br(data.message)}</p></div>`;

        case 'alert':
          return `<div class="ejs-alert m-b-5 ejs-alert-${data.type || 'primary'}" style="white-space:pre-wrap;">${br(data.message)}</div>`;

        case 'button': {
          const flexAlign = { left: 'flex-start', center: 'center', right: 'flex-end' }[data.alignment] || 'center';
          return `<div style="display:flex;justify-content:${flexAlign};margin:20px 0;"><a href="${data.link}" target="_blank" rel="noopener noreferrer" style="background-color:${data.backgroundColor};color:${data.textColor};padding:12px 24px;border-radius:4px;text-decoration:none;font-weight:bold;font-family:sans-serif;white-space:pre-wrap;">${br(data.text)}</a></div>`;
        }

        case 'code':
          return `<pre class="ejs-code m-b-5"><code>${data.code}</code></pre>`;

        case 'embed': {
          if (!data.embed) break;
          const caption = data.caption ? `<figcaption style="text-align:center;margin-top:10px;font-size:14px;color:#666;white-space:pre-wrap;">${br(data.caption)}</figcaption>` : '';
          return `<figure style="margin:30px 0;width:100%;"><div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:8px;"><iframe src="${data.embed}" style="position:absolute;top:0;left:0;width:100%;height:100%;border:none;" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>${caption}</figure>`;
        }

        case 'accordion': {
          const id = `accordion-${block.id}`;
          return `<div class="m-b-5" style="margin:15px 0;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden;"><input type="checkbox" id="${id}" class="css-accordion-toggle"><label for="${id}" class="css-accordion-header"><span>${data.title}</span><span class="css-accordion-icon">+</span></label><div class="css-accordion-content"><div class="css-accordion-inner"><div style="white-space:pre-wrap;">${br(data?.content || '')}</div></div></div></div>`;
        }

        default: return '';
      }
    }).join('\n');
  }

  static renderStyledChecklist(block) {
    const data = block.data;

    // Set defaults just in case older saved data is missing them
    const color = data.color || '#388bfd';
    const borderThickness = data.borderThickness || 1;
    const size = data.size || 20;
    const borderRadius = data.borderRadius !== undefined ? data.borderRadius : 4;
    const align = data.labelAlignment || 'center';

    // Apply the hide mode class if enabled
    const hideCheckboxClass = data.hideCheckbox ? 'hide-checkboxes-mode' : '';

    // 1. Create the wrapper, exactly as Editor.js does, plus your custom class and inline CSS variables
    let html = `
      <div class="custom-styled-checklist cdx-checklist ${hideCheckboxClass}" 
           style="
             --chk-color: ${color}; 
             --chk-border: ${borderThickness}px; 
             --chk-size: ${size}px; 
             --chk-radius: ${borderRadius}px; 
             --chk-align: ${align};
           ">
    `;

    // 2. Loop through the items and build the official DOM structure
    data.items.forEach(item => {
      // Editor.js uses this modifier class to trigger the checked state in CSS
      const checkedClass = item.checked ? 'cdx-checklist__item--checked' : '';

      html += `
        <div class="cdx-checklist__item ${checkedClass}">
          <span class="cdx-checklist__item-checkbox">
            <!-- The inner div where your custom SVG is injected via CSS -->
            <div class="cdx-checklist__item-checkbox-check"></div>
          </span>
          <div class="cdx-checklist__item-text">${item.text}</div>
        </div>
      `;
    });

    html += `</div>`;

    return html;
  }

  /*static nextUid() {
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTime
    const dateObject = new Date();
    const uniqueId = 
      dateObject.getFullYear() + '' + 
      dateObject.getMonth() + '' + 
      dateObject.getDate() + '/' + 
      dateObject.getTime();
    return uniqueId.toString();
  }*/

}

export default CommonService;